/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_StationInputs */

const vi_nav_station = /** @type {(inputs: Nav_StationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máy trạm kho`)
};

/**

* @param {Nav_StationInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_station = /** @type {((inputs?: Nav_StationInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_StationInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_station(inputs)
});